module.exports = __webpack_public_path__ + "img/背景（选择）.17ee1f48.png";